import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { SchoolService } from "../../../../shared/services/school.service";

@Component({
	selector: "app-dza-add-school",
	templateUrl: "./dza-add-school.component.html",
	styleUrls: ["./dza-add-school.component.css"],
})
export class DZAAddSchoolComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private schoolService: SchoolService, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		//Get Data from DB
		this.loadSchoolist();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	lstSchool: any = [];
	SelectedSchools: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
	];

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.UpdateSelected();
			},
			(error) => {}
		);
	}

	UpdateSelected() {
		this.SelectedSchools = this.dialogConfig.data.SelectedSchools;
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		this.ref.close(this.SelectedSchools);
	}
	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
